import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";
import { INITIAL_REDUCER_DATA, IReducerWithIsolated } from "@/main/services/reducerUtils";
import { InsuranceSublineState } from "./insuranceSublineTypes";

export const useInsuranceSublineReducer = (keyReducer: string = "default") => {
	const returnSelector = useSelector((state: ApplicationState) => state.insuranceSubline);
	if (keyReducer === "default") return returnSelector as IReducerWithIsolated<InsuranceSublineState>;

	const updateState = {
		...returnSelector,
		isolated: returnSelector.isolated[keyReducer] ?? INITIAL_REDUCER_DATA,
	};

	return updateState as IReducerWithIsolated<InsuranceSublineState>;
};
